import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { LANGS, DEFAULT_LANG } from "../i18n/translations";
import { LanguageProvider } from "../contexts/LanguageContext";
import Layout from "./Layout";

const VALID = LANGS.map((l) => l.code);

/**
 * Wraps all language-prefixed routes.
 * Validates :lang param and provides LanguageProvider. Renders <Layout><Outlet/></Layout>.
 */
export default function LangLayout() {
  const { lang } = useParams();
  if (!VALID.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return (
    <LanguageProvider>
      <Layout>
        <Outlet />
      </Layout>
    </LanguageProvider>
  );
}
